module.exports = __webpack_public_path__ + "01de3fc6a53e0c9302059c4ec6428667.png";